import actionTypes from "../actionTypes";
import config from "../../config";

export const getRoles = () => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.ROLES_FETCH,
  url: config.api.grantUrl + "/roles"
});

export const getRoleById = roleId => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.ROLE_FETCH,
  url: config.api.grantUrl + "/roles/" + roleId
});



// WEBPACK FOOTER //
// ./src/redux/actions/Roles.js